export default "__VITE_ASSET__C8rmnTD9__"